import { Box, Button, Flex, Heading, Icon, IconButton, Image, Text } from "@chakra-ui/react";
import QrCodePrint from "components/AppQrCodePdfPrint";
import { useAuthentication } from "hooks/useAuthentication";
import { PrinterIcon } from "lucide-react";
import { useRef } from "react";
import { MdLogout } from "react-icons/md";
import { useReactToPrint } from "react-to-print";
import { TAX_PAYER } from "utils/roles";

export default function WelcomeSection() {
  const {
    user,
    authProvider: { signOut },
  } = useAuthentication();
  const handleLogout = async () => {
    await signOut();
  };
  const componentRef = useRef<any>();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  return (
    <>
      {/* welcome section */}
      <Flex
        justifyContent="space-between"
        alignItems="start"
        px={{ base: "20px", sm: "24px" }}
        // flexDirection={{ md: "row", base: "column" }}
        maxWidth={"100%"}
      >
        <Flex
          gap="8px"
          flex={1}
          alignItems="center"
          alignSelf={{ md: "auto", base: "stretch" }}
        >
          <Image
            src={user?.user?.profile_picture || "images/img_frame_1000004630.png"}
            alt="Profile Image"
            h="56px"
            w="56px"
            fit="contain"
            borderRadius="28px"
          />
          <Flex gap="2px" flex={1} flexDirection="column" alignItems="start">
            <Text color="gray_description">Bienvenue</Text>
            <Heading size="button_text_bold_14" as="h1">
              {user?.user?.name}
            </Heading>
          </Flex>
        </Flex>
        {user?.user?.roles === TAX_PAYER && (
          <Button
            size="3xl"
            colorScheme="gray_description"
            fontWeight={700}
            boxShadow="md"
            borderRadius="10px"
            type="submit"
            leftIcon={<PrinterIcon />}
            fontSize={"10px"}
            onClick={handlePrint}
            mr={5}
          >
            Afficher le code QR
          </Button>
        )}
        {user?.user?.roles === TAX_PAYER && (
        <Box display={"none"}>
          <QrCodePrint
            value={user?.user?.tax_identification_number}
            ref={componentRef}
          />
        </Box>
      )}
        <IconButton
          size="3xl"
          colorScheme="red_origin"
          icon={<Icon as={MdLogout as any} boxSize={4} />}
          aria-label="281:4184-Mute Button"
          w="52px"
          borderRadius="14px"
          onClick={handleLogout}
        />
      </Flex>
    </>
  );
}
